import {
  type InferOutput,
  minLength,
  object,
  pipe,
  string,
  number,
  optional,
  trim,
  nullable
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

export const CreateTruckModelDtoSchema = object({
  dcId: optional(number(VALIDATION_MESSAGES.REQUIRED_ITEM)),
  code: pipe(string(), trim(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)),
  name: pipe(string(), trim(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)),
  chargeTypeId: nullable(number())
})

export type CreateTruckModelDto = InferOutput<typeof CreateTruckModelDtoSchema>
